import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import Popup from 'fulogics-ui-web/dist/layout/dx/Popup/Popup';
import style from './OrderLockPopup.module.scss';
import Button from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import * as ids from './inspectorOptions';
import UserModelSimpleText, {
    UserModelSimpleTextDataKeys,
    UserModelSimpleTextData,
} from 'fulogics-ui-web/dist/layout/components/user-model-simple-text/UserModelSimpleText';
import { keysJoin } from 'fulogics-ui-core';

const OrderLockPopup = ({ className, visible, data, onBack }: OrderLockPopupProps) => {
    const { t } = useTranslation('OrderLockPopup');

    return (
        <Popup visible={visible} inspectorId={ids.OrderLockPopupId}>
            <div className={classNames(style.container, className)}>
                <h3>{t('title')}</h3>
                <div className={classNames(style.editor)}>
                    {t('editor')}
                    <UserModelSimpleText
                        className={classNames(style.user)}
                        data={data?.currentEditing?.editingBy as UserModelSimpleTextData}
                        showPicture
                    />
                </div>
                <div>{t('subtitle')}</div>
                <Button
                    className={classNames(style.backButton)}
                    inspectorId={ids.OrderLockPopupBackButtonId}
                    onClick={onBack}
                />
            </div>
        </Popup>
    );
};

export type OrderLockPopupProps = {
    data?: OrderLockPopupData;
} & OrderLockPopupOptions;

export type OrderLockPopupData = {
    currentEditing?: {
        editingBy?: {
            id?: string;
            label?: string;
            fullName?: string;
        };
    };
};

export interface OrderLockPopupOptions {
    className?: string;
    visible?: boolean;
    //
    onBack?: () => void;
}

export const OrderLockPopupDataKeys = [
    ...keysJoin(UserModelSimpleTextDataKeys, 'currentEditing.editingBy.'),
];

export default withInspector<OrderLockPopupProps>(OrderLockPopup, {});
